import { SearchForSuggestionsResultList } from 'aws-sdk/clients/location';

import { searchForLocationSuggestions } from 'src/common/external/aws';
import { authService } from 'src/features/auth/authService';

import { LatLong } from '../external/aws/suggestPois';

export async function queryLocationSuggestions(
  query: string,
  bias?: LatLong
): Promise<SearchForSuggestionsResultList> {
  const token = await authService.getIdToken();
  return searchForLocationSuggestions(query, token, bias);
}
